import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className, delay = 0, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease }}
  >
    {children}
  </motion.div>
);

export const RevealImg = ({ children, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, scale: 1.08 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1.1, ease }}
  >
    {children}
  </motion.div>
);
